import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "establishment" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["innerHTML"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Icon, {
      icon: "graduation-hat-02",
      width: "2.4rem",
      height: "2.4rem"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "position ellipsis",
        innerHTML: $props.edu.degree
      }, null, 8 /* PROPS */, _hoisted_3),
      _createElementVNode("div", {
        class: "institution ellipsis",
        innerHTML: $props.edu.institution
      }, null, 8 /* PROPS */, _hoisted_4),
      _createElementVNode("div", {
        class: "year ellipsis",
        innerHTML: $props.edu.year
      }, null, 8 /* PROPS */, _hoisted_5)
    ])
  ]))
}